import Vue from 'vue'
import MarketingMaterials from './marketing-materials'

Vue.component('marketing-materials', MarketingMaterials)
